import { ChiptaElement, html, css, unsafeHTML, unsafeCSS } from 'chipta-libs/main.js';
import { accountAPI } from 'chipta-libs/api/account.js';
import { getQueryParam } from 'chipta-libs/utils/url.js';
import 'chipta-libs/components/font-awesome.js';
import 'chipta-libs/components/styled-button.js';
import 'chipta-libs/components/arrow-link.js';
import 'chipta-libs/components/styled-input.js';
import './layout/hr-text.js';


class SignUp extends ChiptaElement {

  static get properties() {
    return {
      email: { type: String },
      loading: { type: Boolean },
      saved: { type: Boolean },
      invalidEmail: { type: Boolean }
    };
  }

  render() {

    return html`

      <div id="page-container">

        <div></div>

        <div id="content-container">

          <div id="chipta-logo">
            <img src="img/logowhite.svg" id="chipta-logo">
          </div>

          <div id="pane">

            <div id="signup-form" ?hidden=${this.saved}>

              <h2>${gettext('signup')}</h2>
              <p>${gettext('organizer_signup_description')}</p>

              <form id="form" @submit=${this.handleFormSubmit}>

                <styled-input id="email-input-conainer" ?validate=${this.validate}>
                  <input
                    id="email"
                    type="email"
                    placeholder=${gettext('mail')}
                    required
                    autocomplete="email"
                    pattern="${_emailRegex}"
                    @keyup=${this.handleEmailKeyUp}
                  />
                </styled-input>

                <styled-button
                  id="submit-button"
                  size="big"
                  method="action"
                  style="width: 100%;"
                  ?saving=${this.loading}
                  ?saved=${this.saved}
                >
                  <button style="width: 100%;">${gettext('signup')}</button>
                </styled-button>

                <hr-text id="or-hr">Or:</hr-text>

                <div id="visitor-sign-up-and-login-links">

                  <a class="link" href="/account/sign-up/">

                    <arrow-link direction="right">
                      ${gettext('sign_up_as_visitor')}
                    </arrow-link>

                    <small>
                      ${gettext('visitor_signup_description')}
                    </small>

                  </a>

                  <a class="link" href="/log-in/">

                    <arrow-link direction="right">
                      ${gettext('login')}
                    </arrow-link>

                    <small>
                      ${gettext('signup_login_description')}
                    </small>

                  </a>

                </div>

                <arrow-link id="back-to-website-link" direction="left" href=${this.backToWebsitePath}>
                  ${gettext('back_to_website')}
                </arrow-link>

              </form>

            </div>

            <div id="success-screen" ?hidden=${!this.saved}>

              <h2>
                <font-awesome id="success-icon" icon="check"></font-awesome>
                ${gettext('sign_up_successful')}
              </h2>

              <p>
                ${this.signupConfirmEmailSentDescription}
              </p>

              <div class="links">

                <arrow-link direction="left" href=${this.backToWebsitePath}>
                  ${gettext('back_to_website')}
                </arrow-link>

                <arrow-link id="sign-up-again-link" @click=${this.handleRestartSignup}>
                  ${gettext('sign_up_again')}
                </arrow-link>

              </div>

            </div>

          </div>

        </div>

        <footer id='footer'>
          ${interpolate(gettext('copyright'), {year: (new Date()).getFullYear()}, true)}
        </footer>

      </div>

      <div id="background"></div>

    `;

  }

  get signupConfirmEmailSentDescription() {
    return unsafeHTML(interpolate(
      gettext('signup_confirm_email_sent_description'),
      {email: `<strong>${this.email}</strong>`},
      true
    ));
  }

  get backToWebsitePath() {

    const previousPath = getQueryParam('prev');

    if (previousPath) {
      return previousPath;
    }

    return "/";

  }

  handleRestartSignup() {
    this.saved = false;
    this.el('#email').value = '';
  }

  static get styles() {

    return css`

        :host {
          display: block;
          height: 100vh;
        }

        * {
          box-sizing: border-box;
        }

        [hidden] {
          display: none;
        }

        #background {
          position: fixed;
          z-index: -10;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: ${unsafeCSS(_themeData.brand_primary_color)};
          background-image: url('img/dots.svg');
          background-repeat: no-repeat;
          background-position-y: bottom;
          background-size: 100%;
        }

        #page-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          min-height: 100vh;
        }

        #content-container {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        #chipta-logo {
          display: flex;
          justify-content: center;
          margin: 15px 0;
        }

        #pane {
          width: 100%;
          max-width: 600px;
          padding: 40px;
          border-radius: 10px;
          background: white;
          box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.04),
            0px 20px 25px rgba(0, 0, 0, 0.1);
          font-family: Roboto, sans-serif;
        }

        @media screen and (max-width: 500px) {
          #pane {
            border-radius: 0;
          }
        }

        #signup-form[hidden] {
          display: none;
        }

        #pane h2 {
          margin-bottom: 20px;
          font-family: Raleway, sans-serif;
          font-weight: bold;
          font-size: 25px;
          color: #313131;
        }

        #pane p {
          display: block;
          margin-top: 15px;
          color: #808080;
        }

        #init-text {
          font-size: 16px;
          color: #808080;
        }

        #init-text[user-exists] {
          color: #FF3F44;
        }

        #email {
          height: 50px;
          width: 100%;
          padding-left: 15px;
          margin-bottom: 30px;
          border: 1px solid #C8C8C8;
          border-radius: 5px;
          font-size: 16px;
          color: rgba(87, 87, 87, 0.5);
        }

        #email:focus {
          border-color: #0066FF;
          border-width: 2px;
        }

        #email-input-conainer {
          width: 100%;
        }

        #or-hr {
          margin: 15px 0;
        }

        #visitor-sign-up-and-login-links {
          display: flex;
          justify-content: space-between;
        }

        #visitor-sign-up-and-login-links .link {
          width: 50%;
          padding: 10px 15px;
          background: ${unsafeCSS(_themeData.background_color)};
          border-radius: 15px;
          line-height: initial;
          text-decoration: initial;
          color: initial;
        }

        #visitor-sign-up-and-login-links .link:first-child {
          margin-right: 15px;
        }

        #visitor-sign-up-and-login-links small {
          font-size: 14px;
          line-height: 12px;
        }

        #back-to-website-link {
          display: block;
          margin-top: 15px;
        }

        #success-icon {
          padding: 5px;
          font-size: 25px;
          color: #0066FF;
        }

        .links {
          display: flex;
          justify-content: space-between;
          margin-top: 25px;
        }

        #sign-up-again-link {
          margin-left: 15px;
        }

        #footer {
          margin: 15px;
          color: white;
          font-size: 16px;
        }

    `;

  }

  handleEmailKeyUp(event) {
    this.email = event.target.value;
  }

  handleFormSubmit(event) {

    event.preventDefault();

    this.loading = true;
    this.saved = false;

    accountAPI.requestSignUp(
      this.email, 'organizer'
    ).then(() => {
      this.saved = true;
    }).catch(errors => {
      this.parseErrors(errors);
      this.saved = false;
    }).finally(() => {
      this.loading = false;
    });

  }

  parseErrors(errors) {
    if (
      'email' in errors
      && errors.email[0].code === 'invalid'
    ) {
      this.invalidEmail = true;
    } else {
      this.invalidEmail = false;
    }
  }

}

customElements.define('sign-up', SignUp);
